import React from 'react';

import { PolicyTerms } from '../../../components'; // Importing the reusable PolicyTerms component
import { refundPolicy } from '../../../constants'; // Importing refund policy content from constants


 
const RefundPolicy = () => {
  return (
      <PolicyTerms 
        title="Refund Policy" 
        page="refund-policy" 
        policies={refundPolicy} // Passes the privacy policy content
      />
  );
};

export default RefundPolicy;